import { DEDUCTIONS_PROVIDERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type DeductionDetail = {
  id: number;
  conceptCode: string;
  conceptDescription: string;
  percentage: number;
  beneficiary: string;
  beneficiaryName: string;
};

export type GetDeductionsProvidersResponse = {
  employerIdNumber: string;
  conceptCode: string;
  deduction: DeductionDetail;
}[];

export const getDeductionsProviders = async (
  employerIdNumber: string,
): Promise<GetDeductionsProvidersResponse> => {
  const response = await apiInstance.get<GetDeductionsProvidersResponse>(
    DEDUCTIONS_PROVIDERS,
    {
      params: { employerIdNumber },
    },
  );
  return response.data;
};
